import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import CloseIcon from '@mui/icons-material/Close';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import { Box, Grid } from '@mui/material';
import React from 'react';
import { IJob } from 'wisestep-api';
import { WsTypography, WsTypoVariants, WsTypoColors, WsIconText, WsColors } from 'wisestep-base';
export interface IBulkJobDetailsCard {
  jobsData: IJob;
  onClick: React.MouseEventHandler;
}
const BulkJobDetailsCard = ({ jobsData, onClick }: IBulkJobDetailsCard) => {
  const cityAndCountry = jobsData.locations?.map((place) => `${place.city} , ${place.country}`);

  return (
    <Grid container bgcolor={WsColors.TheBlues50} spacing={3} p={1}>
      <Grid item xs={4}>
        {jobsData.title && (
          <Grid container item>
            <Box pt={0.5} pr={0.5}>
              <BusinessCenterIcon color="info" />
            </Box>
            <Box>
              <WsTypography
                variant={WsTypoVariants.SUB_TITLE}
                color={WsTypoColors.SENARY}
                display="inline"
              >
                {jobsData.title}
              </WsTypography>
            </Box>
          </Grid>
        )}
      </Grid>

      <Grid item xs={2}>
        <WsIconText
          icon={<CorporateFareIcon color="action" />}
          text={jobsData.companyName ?? 'No client name'}
          opacity={true}
        />
      </Grid>
      <Grid item xs={2}>
        <WsTypography
          variant={WsTypoVariants.SUB_TITLE}
          color={WsTypoColors.TERTIARY}
          display="inline"
        >
          {jobsData.jobCode ?? ''}
        </WsTypography>
      </Grid>
      {cityAndCountry && (
        <Grid item xs={3}>
          <WsIconText
            icon={<FmdGoodOutlinedIcon color="action" />}
            text={cityAndCountry[0]}
            opacity={true}
          />
        </Grid>
      )}
      <Grid item xs={1}>
        <CloseIcon cursor={'pointer'} onClick={onClick} />
      </Grid>
    </Grid>
  );
};

export default BulkJobDetailsCard;
